function myaccount() {
  //login signup
  $('.login--tabs').on('click', 'button', function() {
    if ($(this).attr('data-deploy') == 'login') {
      $('.login--tabs button').removeClass('active');
      $(this).addClass('active');
      $('.login-container .login-form').show();
      $('.login-container .register-block').hide();
    } else {
      $('.login--tabs button').removeClass('active');
      $(this).addClass('active');
      $('.login-container .login-form').hide();
      $('.login-container .register-block').show();
    }
  });

  //My account - info
  $('.my-info .addresses-slider').slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    responsive: [
      {
        breakpoint: 999999,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        }
      }
    ],
  });

  $('.my-address-delete').click(function(e) {
    var $this = $(this);
    e.preventDefault();

    $.ajax({
      method: 'POST',
      url: mantion.ajaxurl,
      data : {
        action: "mtn_remove_user_address",
        id: $(this).attr('data-key'),
      },
      success: function(data) {
        if (data.success) {
          $this.closest('.address-slider-item').remove();
        }
      },
    });
  });

  $('.woocommerce-account .dashboard .products').slick({
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    responsive: [
      {
        breakpoint: 999999,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.send-a-reseller-estimate').on('ajax:post:send-a-reseller-estimate:success', function (response, data) {
    $(this).replaceWith(data.html);
  });
  $('.send-a-reseller-estimate').on('ajax:post:send-a-reseller-estimate:error', function (response, data) {
    alert(data);
  });

  $('.client-was-contacted').on('ajax:post:client-was-contacted:success', function (response, data, params) {
    $(this).closest('td').html(data.html);

    if (params.answer === 'yes') {
      alert(mantion.mymantion.reseller_estimate.client_was_contacted);
    }
    else {
      alert(mantion.mymantion.reseller_estimate.client_wasnt_contacted);
    }
  });
  $('.client-was-contacted').on('ajax:post:client-was-contacted:error', function (response, data) {
    alert(data);
  });

  if ($('.woocommerce-MyAccount-navigation').length) {
    $('.woocommerce-MyAccount-navigation ul').scrollLeft($('li.is-active').offset().left - $('li.is-active').width() / 2);
  }

  $('.cancel-estimate').on('click', function (e) {
    return confirm(mantion.mymantion.cancel_estimate.confirm);
  });
}

export { myaccount };
